import React from "react";
import { Link } from "react-router-dom";
import logo from "assets/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between">
          {/* Logo and Company Info */}
          <div className="mb-6 md:mb-0 md:w-1/3">
            <Link to="/" className="inline-block mb-4">
              <img src={logo} alt="Dijla" className="h-10 object-contain" />
            </Link>
            <p className="text-gray-600 text-sm mb-4">
              Dijla Clearing & Forwarding provides professional logistics and
              customs clearance services across the Middle East region.
            </p>
          </div>

          {/* Quick Links */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-gray-800 font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-600 hover:text-[#003F75] text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/tracking"
                  className="text-gray-600 hover:text-[#003F75] text-sm"
                >
                  Tracking
                </Link>
              </li>
              <li>
                <Link
                  to="/announcements"
                  className="text-gray-600 hover:text-[#003F75] text-sm"
                >
                  Announcements
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-600 hover:text-[#003F75] text-sm"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-gray-800 font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li className="text-gray-600 text-sm">Email: info@dijla.com</li>
              <li className="text-gray-600 text-sm">Phone: +974 5555 5555</li>
              <li className="text-gray-600 text-sm">Address: Doha, Qatar</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-200 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            © {currentYear} Dijla Clearing & Forwarding. All rights reserved.
          </p>
          <div className="flex space-x-4">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-[#003F75] text-sm">
              Privacy Policy
            </Link>
            <a href="#" className="text-gray-500 hover:text-[#003F75] text-sm">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
